import React from 'react';
import {observer} from 'mobx-react';
import {SelectedGameFromSdmComponent} from './selected-game-from-sdm/selected-game-from-sdm.component';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import Divider from '@material-ui/core/Divider';

const styles = (theme: Theme) => createStyles({
    paper: {
        border: '1px solid',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    }
});

export interface AddGamesFromSdmComponentProps extends WithStyles<typeof styles> {

}

export const AddGamesFromSdmComponent = withStyles(styles)(

    observer(
        class extends LauncherComponentBase<AddGamesFromSdmComponentProps> {

            private _renderNoGamesSelectedMessage() {
                return (
                    <div style={{marginTop:'30px'}}>Currently there are no games added. Use the search box above to search for games and add them to the customization list.</div>
                );
            }

            private _renderSelectedGames(gameTypes: number[]) {
                return (<div>
                    {
                        gameTypes.map(gameType => (
                            <div key={gameType}>
                                <SelectedGameFromSdmComponent gameType={gameType}/>
                                <Divider/>
                            </div>))
                    }
                </div>)
            }

            render() {
                let gameTypes = this.services.gamesCustomization.getSelectedGamesFromSdm();

                return (
                    <div style={{marginLeft: '10px'}}>
                        <h1>Add games from SDM</h1>
                        <Divider/>
                        {gameTypes.length === 0 ? this._renderNoGamesSelectedMessage() : this._renderSelectedGames(gameTypes)}
                    </div>
                );
            }
        }
    )
);




